import React from "react";

import OptimaxWebLogo from "~/assets/image/optimaxweb.png?inline";
import { APP_DESCRIPTOR } from "~/constants";

export function SplashScreenTitleWithLogo() {
    return (
        <>
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    alignContent: "center",
                    gap: "5px",
                    justifyContent: "center",
                }}
            >
                <img
                    // TODO: Update this image to fit to Hammerfall system
                    src={OptimaxWebLogo}
                    alt="Embedded Base64 Image"
                    width="48"
                    height="48"
                    style={{ margin: "-5px 0px" }}
                />
                {APP_DESCRIPTOR.name}
            </div>
        </>
    );
}
